import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import { isStaging } from "@/webflow/is-staging";

export default function (element, dataset) {
  let tl = gsap.timeline({
    scrollTrigger: {
      start: "top bottom",
      end: "bottom top",
      scrub: 1.5,
      trigger: element,
    },
    defaults: {
      ease: "none",
    },
  });

  tl.fromTo(
    element,
    {
      x: "-20%",
    },
    {
      x: "20%",
    },
  );

  onDestroy(() => {
    tl.kill();
  });
}
